import controller from './paycell-card-add.controller';
import './paycell-card-add.less';

export default {
  controller,
  template: require('./paycell-card-add.html')
};



// WEBPACK FOOTER //
// src/app/buy/paycell-card-add/paycell-card-add.component.ts